export enum SearchTermActions {
  setCurrentSearchTerm = 'setCurrentSearchTerm',
}

export interface ISearchTermAction {
  type: SearchTermActions;
  payload: boolean;
}
type ISearchTermStateAction = {
  type: SearchTermActions.setCurrentSearchTerm;
  payload: string | 'TERM_UNKNOWN';
};

export type ISearchTermDispatch = (action: ISearchTermStateAction) => void;

export interface ISearchTermState {
  currentSearchTerm: string | 'TERM_UNKOWN';
}

export const searchTermReducer = (state: ISearchTermState, action: ISearchTermStateAction) => {
  switch (action.type) {
    case SearchTermActions.setCurrentSearchTerm:
      state.currentSearchTerm = action.payload;
      break;
    default:
      return state;
  }
  return state;
};
